module.exports = __webpack_public_path__ + "img/ExamTypes.38e04580.svg";